module.exports = __webpack_public_path__ + "static/media/table-tennis.1ecd69f4.webp";